<!-- Accordion -->
<div class="accordion" id="accordionPatients">
  <!-- Card inside Accordion, Card Header -->
  <div style="margin-bottom: 1px;" class="card" *ngFor="let patient of patients | async; let i = index">
    <div class="card-header" id="heading{{i}}">
      <h5 class="mb-0">
        {{patient.name}}
        <button class="btn btn-link float-right pt-0 pb-0 collapsed"
          type="button"
          data-toggle="collapse"
          [attr.data-target]="'#collapsePatient' + i"
          aria-expanded="false" [attr.aria-controls]="'collapsePatient' + i"
          (click)="editing = false">
          <fa-icon [icon]="eyeIcon" data-toggle="tooltip" title="Cadastro paciente"></fa-icon>
        </button>
        <button class="btn btn-link float-right pt-0 pb-0"
          type="button" routerLink="{{patient.id}}/atendimento">
            <fa-icon [icon]="addressCard" data-toggle="tooltip" title="Prontuário paciente"></fa-icon>
        </button>
      </h5>
    </div>

    <!-- Accordion collapsible part, Card Body -->
    <div id="collapsePatient{{i}}" class="collapse" [attr.aria-labelledby]="heading" data-parent="#accordionPatients">
      <div class="card-body">
        <!-- Editing action buttons -->
        <div class="float-right">
          <button [hidden]="editing" (click)="startEditing()" class="btn btn-link">
            <fa-icon icon="pencilAlt"></fa-icon>
          </button>
          <button [hidden]="!editing" (click)="editing = false" class="btn btn-link">
            <fa-icon [icon]="timesCircle" size="lg" style="color: red;"></fa-icon>
          </button>
          <button [hidden]="!editing" class="btn btn-link">
            <fa-icon [icon]="checkCircle" size="lg"></fa-icon>
          </button>
        </div>
        <!-- Patient data form -->
        <form>
          <div class="form-group">
            <label for="name">Nome</label>
            <input disabled class="form-control" type="text" id="name" value="{{patient.name}}" />
          </div>
          <div class="form-group">
            <label for="dob">Nascimento</label>
            <input disabled class="form-control" type="text" id="dob" value="{{patient.dob | date:format:short}}" />
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
